"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SuccessMessage", {
  enumerable: true,
  get: function get() {
    return _SuccessMessage.default;
  }
});
var _SuccessMessage = _interopRequireDefault(require("./SuccessMessage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }